import datapoints from '../datapoints';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { lazyGetItemProperties } from 'owa-get-item-manager';
import { ClientItem } from 'owa-mail-store';
import { getExtendedProperty } from 'owa-mail-store/lib/utils/getExtendedPropertyValue';
import { isFeatureEnabled } from 'owa-feature-flags';
import Item from 'owa-service/lib/contract/Item';
import {
    featureId,
    TRANSLATION_DATA_PROPERTY_NAME,
    TRANSLATION_STATUS_PROPERTY_NAME,
    TRANSLATION_STATUS_V2_PROPERTY_NAME,
} from '../utils/inlineTranslationDataAndStatusItemPropertyEntry';

export default createLegacyActionWithDatapoint(
    'storeTranslationData',
    datapoints.InlineTranslationLoadDataAndStatus
)(async function loadTranslationDataAndStatus(item: ClientItem): Promise<string[]> {
    let updatedItem: Item = null;
    try {
        const getItemProperties = await lazyGetItemProperties.import();
        updatedItem = await getItemProperties(item.ItemId.Id, featureId);
    } catch (e) {
        // Ignore error
        const dataPoint = returnTopExecutingActionDatapoint();
        dataPoint?.endWithError(DatapointStatus.ServerError, new Error(e.responseMessage));
    }

    if (updatedItem) {
        const dataProp = getExtendedProperty(
            updatedItem,
            null /*tag*/,
            TRANSLATION_DATA_PROPERTY_NAME
        );

        let statusProp;
        if (isFeatureEnabled('tra-useTranslationStatusV2')) {
            statusProp = getExtendedProperty(
                updatedItem,
                null /*tag*/,
                TRANSLATION_STATUS_V2_PROPERTY_NAME
            );
        }

        if (!statusProp) {
            statusProp = getExtendedProperty(
                updatedItem,
                null /*tag*/,
                TRANSLATION_STATUS_PROPERTY_NAME
            );
        }

        return [dataProp ? dataProp.Value : null, statusProp ? statusProp.Value : null];
    }

    return [null, null];
});
